export const attachmentDetailsSectionStyles = {
  wrapper: {
    width: 460,
    borderLeft: '1px solid',
    overflow: 'hidden',
    borderColor: 'neutral.outlineVariant'
  },
  mobileWrapper: {
    width: '100%',
    flex: 1,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    p: 2
  },
  mobileWrapperChildrenContainer: {
    flex: 1,
    minHeight: 0,
  },
  collapse: {
    maxHeight: '50%',
    overflow: 'auto'
  }
};